import { Component, OnInit } from '@angular/core';

import { ListResponse } from '../../../../../models/list-response';
import {
  getPaymentProcessorTypeDisplay,
  PaymentProcessorConnection
} from '../../../../../models/organization-config';
import { AccountService } from '../../../../../services/account/account.service';
import { OrganizationConfigService } from '../../../../../services/organization-config/organization-config.service';
import { environment } from '../../../../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleMessageModalComponent } from '../../../../../components/modals/simple-message-modal/simple-message-modal.component';
import { Router } from '@angular/router';
import { AssignPaymentProcessorConnectionModalComponent } from './modals/assign-payment-processor-connection-modal/assign-payment-processor-connection-modal.component';
import { CallbackResult, CallbackResultStatus } from '../../../../../utils';
import { LocationService } from '../../../../../services/location/location.service';
import {
  AddMxMerchantConnectionModalComponent
} from './modals/add-mx-merchant-connection-modal/add-mx-merchant-connection-modal.component';


@Component({
  selector: 'app-payment-processor-connections',
  templateUrl: './payment-processor-connections.component.html',
  styleUrls: ['./payment-processor-connections.component.css']
})
export class PaymentProcessorConnectionsComponent implements OnInit {
  public conns: ListResponse<PaymentProcessorConnection>;

  public loadingConns = false;

  public successMessage = '';
  public errorMessage = '';
  public modalResult: CallbackResult = null;

  public serverError: number = null;

  // Make browser history available to the template.
  public history: History;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public getPaymentProcessorTypeDisplay = getPaymentProcessorTypeDisplay;
  public CallbackResultStatus = CallbackResultStatus;

  constructor(
    public accountService: AccountService,
    private orgConfigService: OrganizationConfigService,
    private locationService: LocationService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }

    // Make browser history available to the template.
    this.history = history;

    this.loadConns();
  }

  public resultsPresent() {
    return this.conns && this.conns.results && (this.conns.results.length > 0);
  }

  public handleAssignConn(conn: PaymentProcessorConnection) {
    this.successMessage = '';
    this.errorMessage = '';
    this.modalResult = null;

    const modalRef = this.modalService.open(AssignPaymentProcessorConnectionModalComponent);
    modalRef.componentInstance.conn = conn;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.loadConns();
      this.locationService.loadLocations();
    };
  }

  public handleRemoveConn(conn: PaymentProcessorConnection) {
    this.successMessage = '';
    this.errorMessage = '';
    this.modalResult = null;

    const modalRef = this.modalService.open(SimpleMessageModalComponent);
    modalRef.componentInstance.headerText = 'Remove Payment Processor Connection';
    modalRef.componentInstance.messageText = 'Are you sure you want to remove the "' + conn.name + '" payment processor connection? We recommend you leave the payment processor unassigned for at least a week before removing it, to avoid issues with refunds and in-progress payments. Removing the payment processor connection will also remove any saved payment methods and card readers for the connection.';
    modalRef.componentInstance.messageAlertClass = 'alert-danger';
    modalRef.componentInstance.hasConfirmation = true;
    modalRef.componentInstance.confirmedCallback = () => {
      this.loadingConns = true;

      this.orgConfigService
        .removePaymentProcessorConnection(conn.url)
        .then(() => {
          this.successMessage = 'Connection "' + conn.name + '" removed successfully.';
        })
        .catch(reason => {
          if (reason.status === 403) {
            this.errorMessage = 'You do not have permission to remove this connection.'
          } else {
            this.serverError = reason.status;
          }
        })
        .finally(() => {
          this.loadConns();
          this.locationService.loadLocations();
        });
    };
  }

  public getStripeOAuthInitURL() {
    return environment.api_url + 'stripe/oauth-init/?token=' + this.accountService.getToken();
  }

  public openAddMxMerchantConnectionModal() {
    this.successMessage = '';
    this.errorMessage = '';
    this.modalResult = null;

    const modalRef = this.modalService.open(AddMxMerchantConnectionModalComponent);
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.loadConns();
    };
  }

  private loadConns() {
    this.loadingConns = true;

    this.orgConfigService
      .getPaymentProcessorConnections(1, 1000)
      .then(response => {
        this.conns = response;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingConns = false; });
  }
}
